// eslint-disable-next-line no-unused-vars
function initSlider(){
  const curLang = $('html').attr('lang');
  let prevText = '';
  let nextText = '';
  switch (curLang) {
    case 'de':
      prevText = 'Weiter';
      nextText = 'Zurück';
      break;
    default:
      prevText = 'Previous';
      nextText = 'Next';
  }
  const slickPrev = `<button class="slick-prev" aria-label="Previous" type="button">${prevText}</button>`;
  const slickNext = `<button class="slick-next" aria-label="Next" type="button">${nextText}</button>`;
  const breakpointsBS = {
    xl: {
      width: 1400,
    },
    lg: {
      width: 1200,
    },
    md: {
      width: 992,
    },
    sm: {
      width: 768,
    },
    xs: {
      width: 480,
    },
  };

  /**
   * logo slider
   */
  let breakpointsLogoSlider = breakpointsBS;
  breakpointsLogoSlider.xxl = {
    items: 10,
  };
  breakpointsLogoSlider.xl.items = 8;
  breakpointsLogoSlider.lg.items = 6;
  breakpointsLogoSlider.md.items = 5;
  breakpointsLogoSlider.sm.items = 3;
  breakpointsLogoSlider.xs.items = 2;

  $('.logo-parade-slider').each(function() {
    let slider = $(this);
    let slideritems = slider.children().length;
    let options = {
      arrows: false,
      dots: false,
      infinite: false,
      speed: 350,
      slidesToShow: 10,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4500,
      pauseOnHover: true,
      responsive: [],
    };

    Object.keys(breakpointsLogoSlider).forEach(function(key) {
      let infinite = (slideritems > breakpointsLogoSlider[key].items);
      if (key === 'xxl') {
        options.slidesToShow = breakpointsLogoSlider[key].items;
        options.infinite = infinite;
      } else {
        options.responsive.push({
          breakpoint: breakpointsLogoSlider[key].width,
          settings: {
            slidesToShow: breakpointsLogoSlider[key].items,
            infinite: infinite,
          },
        });
      }
    });

    try {
      $(this).slick(options);
    } catch (error) {
      console.error(error);
    }
  });

  /**
   * slider teaser with text
   */
  let breakpointsTeaserSlider = breakpointsBS;
  breakpointsTeaserSlider.xl.items = 4;
  breakpointsTeaserSlider.lg.items = 3;
  breakpointsTeaserSlider.md.items = 2;
  breakpointsTeaserSlider.sm.items = 1;
  breakpointsTeaserSlider.xs.items = 1;

  $('.teaser-slider').each(function() {
    let slider = $(this);
    let options = {
      arrows: true,
      prevArrow: slickPrev,
      nextArrow: slickNext,
      dots: false,
      infinite: false,
      speed: 350,
      slidesToShow: breakpointsTeaserSlider.xl.items,
      slidesToScroll: 1,
      autoplay: false,
      responsive: [],
    };
    sliderAddBreakpointSettings(breakpointsTeaserSlider, options);

    try {
      slider.slick(options);
    } catch (error) {
      console.error(error);
    }
  });

  /**
   * slider teaser with text
   */
  let breakpointsTeaserSliderSmall = breakpointsBS;
  breakpointsTeaserSliderSmall.xl.items = 2;
  breakpointsTeaserSliderSmall.lg.items = 1;
  breakpointsTeaserSliderSmall.md.items = 2;
  breakpointsTeaserSliderSmall.sm.items = 1;
  breakpointsTeaserSliderSmall.xs.items = 1;

  $('.teaser-slider-small').each(function() {
    let slider = $(this);
    let options = {
      arrows: true,
      prevArrow: slickPrev,
      nextArrow: slickNext,
      dots: false,
      infinite: false,
      speed: 350,
      slidesToShow: breakpointsTeaserSliderSmall.xl.items,
      slidesToScroll: 1,
      autoplay: false,
      responsive: [],
    };
    sliderAddBreakpointSettings(breakpointsTeaserSliderSmall, options);

    try {
      slider.slick(options);
    } catch (error) {
      console.error(error);
    }
  });

  /**
   * slider video gallery
   */
  let breakpointsVideoGallery = breakpointsBS;
  breakpointsVideoGallery.xl.items = 5;
  breakpointsVideoGallery.lg.items = 4;
  breakpointsVideoGallery.md.items = 3;
  breakpointsVideoGallery.sm.items = 2;
  breakpointsVideoGallery.xs.items = 1;

  $('.videogallery-wrap').each(function() {
    let slider = $(this);
    let options = {
      arrows: true,
      prevArrow: slickPrev,
      nextArrow: slickNext,
      dots: false,
      infinite: false,
      speed: 350,
      slidesToShow: breakpointsVideoGallery.xl.items,
      slidesToScroll: 1,
      autoplay: false,
      responsive: [],
    };
    sliderAddBreakpointSettings(breakpointsVideoGallery, options);

    try {
      slider.slick(options);
    } catch (error) {
      console.error(error);
    }
  });

  /**
   * slider background image gallery
   */
  $('.background-slider').each(function() {
    let slider = $(this);
    let options = {
      arrows: false,
      dots: false,
      infinite: true,
      fade: true,
      speed: 350,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 7500,
      pauseOnHover: true,
      responsive: [],
    };
    try {
      slider.slick(options);
    } catch (error) {
      console.error(error);
    }
  });

}

function sliderAddBreakpointSettings (breakpoints, options) {
  Object.keys(breakpoints).forEach(function(key) {
    options.responsive.push({
      breakpoint: breakpoints[key].width,
      settings: {
        slidesToShow: breakpoints[key].items,
      },
    });
  });
}
